import { z } from 'zod';
import { requiredString } from '../helpers';
export const Talkdesk_Handoff_1_ConfigValidator = z.object({
    connection: requiredString('Talkdesk Connection is required'),
    touchpointId: requiredString('Digital Connect Touchpoint ID is required'),
    customerEmail: requiredString('Customer Email is required'),
    customerName: z.string().optional(),
    customerPhone: z.string().optional(),
    subject: z.string().optional()
});
//# sourceMappingURL=talkdesk-handoff-1.js.map